import styled from 'styled-components';

export const Container = styled.div``;

export const ErrorMenssage = styled.span`
  color: #e32f10;
`;
